function formatProductCode(product) {
  return product.codeVariant;
}

export { formatProductCode };
